// ** React Imports
import React, { useImperativeHandle, useRef } from 'react'

// ** Icon Imports
import { Calendar } from '../../icons'

interface IProps {
	id: string
	label?: string
	startDate: Date | null
	// flat=true: the label is rendered above by the parent DatePicker, so skip it here
	flat?: boolean
}

export const DatePickerInput = React.forwardRef<HTMLInputElement, IProps>(
	(props, ref) => {
		const innerRef = useRef<HTMLInputElement>(null)
		const { startDate, label, id, flat, ...restProps } = props

		useImperativeHandle(ref, () => innerRef?.current as HTMLInputElement)

		return (
			<div className='custom-date-picker-input'>
				<input {...restProps} id={id} ref={innerRef} placeholder=' ' />
				{/* In flat mode the label is rendered above by the parent DatePicker */}
				{!flat && (
					<label {...restProps} htmlFor={id}>
						{label ?? 'Year'}
					</label>
				)}
				{!startDate && <Calendar />}
			</div>
		)
	}
)
